import UploadStock from "../components/StockManagement/UploadStock";

const StockUploadPage = () => {
  return <UploadStock />;
};

export default StockUploadPage;
